// Craft content interfaces
export interface WebinarScheduleContent {
  courseid: string;
}

// Xgrit Webinar Response
export interface WebinarScheduleResponse {
  title: string;
  courseId: string;
  courseKey: string;
  sessionList: WebinarScheduleSessionList[];
  category: {
    code: string;
    title: string;
  };
  webinarTitle?: string;
  webinarContent?: string;
}

export interface WebinarScheduleSessionList {
  title: string;
  eventsList: WebinarScheduleEventList[];
}

export interface WebinarScheduleEventList {
  day: string;
  time: string;
  eventId?: string;
}

export enum WebinarCategory {
  BrokerPreLicense = 'Broker Pre-License',
  ContinuingEd = 'Continuing Ed',
  ManagingBrokerPreLicense = 'Managing Broker Pre-License',
  PreLicense = 'Pre-License',
  ResidentialLeasingAgentPreLicense = 'Residential Leasing Agent Pre-License',
}

// EPS-4414 (AC9 decision): no CategoryCode.HSP was added. Hospitality has no confirmed
// webinar-scheduling requirement at launch, and speculatively wiring a new category plus
// its ViewChild templates/case branches (webinar-schedule.component.ts) without a real
// product requirement would be scope creep beyond this ticket. Revisit if/when Hospitality
// webinars are scoped — see concerns.md.
export enum CategoryCode {
  INS = 'INS',
  MTG = 'MTG',
  RE = 'RE',
}

export function isWebinarCategory(value?: string): value is WebinarCategory {
  return !!value && (Object.values(WebinarCategory) as string[]).includes(value);
}

export function isCategoryCode(value?: string): value is CategoryCode {
  return !!value && (Object.values(CategoryCode) as string[]).includes(value);
}
